var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "96px",
    height: "96px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.86523,11.00391c-0.33012,0.02225 -0.65441,0.12705 -0.94141,0.31055c-0.576,0.368 -0.92383,1.00255 -0.92383,1.68555v38c0,0.683 0.34783,1.31755 0.92383,1.68555c0.326,0.208 0.70017,0.31445 1.07617,0.31445c0.286,0 0.5738,-0.06155 0.8418,-0.18555l41,-19c0.707,-0.327 1.1582,-1.03545 1.1582,-1.81445c0,-0.779 -0.4512,-1.48645 -1.1582,-1.81445l-41,-19c-0.3095,-0.1435 -0.64644,-0.20389 -0.97656,-0.18164zM16,16.13086l34.24219,15.86914l-34.24219,15.86719v-11.0957l18.94727,-3.79102c1.072,-0.214 1.072,-1.74694 0,-1.96094l-18.94727,-3.79102z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3e31ade306227c5708bb0af1b64187b5.svg";
export { ForwardRef as ReactComponent };